module.exports = __webpack_public_path__ + "img/preview.2906901f.jpg";